import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
export default function UserAccountWrapper() {
  const userReducer = useSelector((state) => state.userReducer);
  const getUserDetails = userReducer.currentUser;
  const bankDetailReducer = useSelector((state) => state.bankDetailReducer);
  const getBankDetails = bankDetailReducer.bankDetails;

  return getUserDetails !== null ? (
    <div>
      <div class="account_top_information">
        <div class="account_overlay"></div>
        <div class="useriimg">
          {getUserDetails.imageUrl === undefined ? (
            <img src="images/user.png" alt="users" />
          ) : (
            <img src={getUserDetails.imageUrl} alt="users" />
          )}
        </div>
        <div class="userdet uderid">
          <h3>
            {getUserDetails.firstName
              ? getUserDetails.firstName
              : getUserDetails.emailAddress}
          </h3>

          <dl class="userdescc">
            <dt>Registration Date</dt>
            <dd>: &nbsp; {getUserDetails.creationTime}</dd>
            <dt>Last Login</dt>
            <dd>: &nbsp; {getUserDetails.lastLogin}</dd>
            <dt>Current Login</dt>
            <dd>: &nbsp; {moment().format("MMMM Do YYYY, h:mm:ss a")}</dd>
          </dl>
        </div>

        <div class="userdet user_transcation">
          <h3>Available Balance</h3>
          {getBankDetails ? (
            <dl class="userdescc">
              {getUserDetails.payPal ? (
                <span>
                  {" "}
                  <dt>Paypal</dt>
                  <dd>:&nbsp;&nbsp;${getBankDetails.payPalBalance + ".00"}</dd>
                </span>
              ) : (
                ""
              )}
              {getUserDetails.bitcoinAddress ? (
                <span>
                  <dt>Bitcoin</dt>
                  <dd>:&nbsp;&nbsp;${getBankDetails.bitcoinBalance + ".00"}</dd>
                </span>
              ) : (
                ""
              )}
              {getUserDetails.accountNumber ? (
                <span>
                  {" "}
                  <dt>Cash Deposit</dt>
                  <dd>:&nbsp;&nbsp;${getBankDetails.cashDeposit + ".00"}</dd>
                </span>
              ) : (
                ""
              )}
              {getUserDetails.cashApp ? (
                <span>
                  {" "}
                  <dt>Cash app</dt>
                  <dd>:&nbsp;&nbsp;${getBankDetails.cashAppBalance + ".00"}</dd>
                </span>
              ) : (
                ""
              )}
              {getUserDetails.wireTransferBalance ? (
                <span>
                  {" "}
                  <dt>Wire Transfer Balance</dt>
                  <dd>
                    :&nbsp;&nbsp;$
                    {getBankDetails.wireTransferBalance + ".00"}
                  </dd>
                </span>
              ) : (
                ""
              )}
            </dl>
          ) : (
            <dl class="userdescc">
              {" "}
              <dt>Not active</dt>
            </dl>
          )}
        </div>
        {/* <div class="userdet user_transcation">
          <h3 class="none_headung"> &nbsp;</h3>
          <dl class="userdescc">
            <dt>EGOpay</dt>
            <dd>:&nbsp;&nbsp;$ 0</dd>
            <dt>OKpay</dt>
            <dd>:&nbsp;&nbsp;$ 0</dd>
            <dt>Solidtrustpay </dt>
            <dd>:&nbsp;&nbsp;$ 0</dd>
            <dt>Webmoney</dt>
            <dd>:&nbsp;&nbsp;$ 450</dd>
            <dt>Bankwire</dt>
            <dd>:&nbsp;&nbsp;$ 799</dd>
            <dt>Bitcoin</dt>
            <dd>:&nbsp;&nbsp;$ 33584</dd>
          </dl>
        </div> */}
      </div>
    </div>
  ) : (
    ""
  );
}
